<template>
  <div
    :class="$style.root"
  >
    <LayoutPageHeaderComponent
      :data="localizedData"
      :image="coverImageFromBlocks"
    >
      <CoreDateTimeRangeComponent
        :dateStart="localizedData?.date_start"
        :dateEnd="localizedData?.date_end"
        :class="$style.dates"
      />
    </LayoutPageHeaderComponent>

    <CoreBlocksComponent
      v-if="blocks"
      :blocks="blocks"
      :data-last-block-is-image-block="lastBlocksIsImageBlock ? '' : null"
      :class="$style.blocks"
    />

    <div
      v-if="localizedData?.publication || localizedData?.credits"
    >
      <PagesExhibitionsSlugPublicationComponent
        v-if="localizedData?.publication"
        :data="localizedData.publication"
      />

      <PagesExhibitionsSlugCreditsComponent
        v-if="localizedData?.credits"
        :data="localizedData.credits"
      />

      <PagesExhibitionsSlugSiblingsComponent
        v-if="siblingsData?.data?.length"
        :data="siblingsData.data"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  pageData: Object,
  siblingsData: {
    type: Array,
    required: false
  }
})

const localizedData = computed(() => i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data)))
const firstBlockIsCoverImage = computed(() => pageGetFirstBlocksIsCoverImage(localizedData.value?.blocks))
const coverImageFromBlocks = computed(() => pageGetFirstImageFromBlocks(localizedData.value?.blocks, firstBlockIsCoverImage.value))
const blocks = computed(() => pageGetBlocks(localizedData.value?.blocks, firstBlockIsCoverImage.value))
const lastBlocksIsImageBlock = computed(() => localizedData.value?.blocks?.pop()?.__component === 'blocks.images')
</script>

<style module>
.root {
  position: relative;

  display: flex;
  flex-direction: column;
  gap: calc(var(--unit--vertical) * 3);
}

.dates {
  composes: font-size-large from global;
}
</style>
